import { useEffect, useState, useRef } from 'react'
import { ChatsView } from '../../views'
import { UsageService } from '../../../services'
import socketio from 'socket.io-client'
import { useGlobalState } from '../../../GlobalState'

const ChatsAction = () => {
  // #region variables
  const url = process.env.REACT_APP_ETICKET_API
  const chatbotUrl = process.env.REACT_APP_CHATBOT_URL
  const usageService = new UsageService(url)
  const [chats, setChats] = useState([])
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState(null)
  const socketRef = useRef(null)
  const chatsRef = useRef([])
  const { botConfig } = useGlobalState()
  // #endregion variables
  
  // #region effects
  useEffect(() => {
    chatsRef.current = chats
  }, [chats])

  useEffect(() => {
    handleLoadChats()
  }, [botConfig])
  // #endregion effects
  
  // #region methods
  const handleLoadChats = () => {
    if (botConfig?.id) {
      if (socketRef.current) {
        socketRef.current.disconnect()
      }

      handleGetChats()
      handleConnectSocketChat()
    }
  }

  const handleGetChats = async () => {
    const token = JSON.parse(localStorage.getItem('token')).accessToken
    const response = await usageService.getConversationsByMonth('', '', token, 'today', botConfig?.id)
    setChats(response)
    setLoading(false)
    setToken(token)
  }

  /**
   * @description method to connect socket
   */
  const handleConnectSocketChat = () => {
    try {
      // connect socket

      console.log(process.env.REACT_APP_SOCKET_ASSISTANT)
      socketRef.current = socketio.connect(process.env.REACT_APP_SOCKET_ASSISTANT)

      socketRef.current.on('connect', () => {
        console.log('socket connected -> ', socketRef.current.id)
      })

      socketRef.current.on('connect_error', (error) => {
        console.log('connect error -> ', error.message)
      })

      socketRef.current.on('newConversationCreated', (response) => {
        handleReloadChats(response)
      })

      socketRef.current.on('conversationClosed', (response) => {
        handleReloadChats(response)
      })

      socketRef.current.on('messageActivity', (response) => {
        handleReloadChats(response)
      })

      socketRef.current.on('changeMode', (response) => {
        handleCheckConversationModeChanged(response)
      })

      // clean when dismount component
      return () => {
        if (socketRef.current) {
          socketRef.current.disconnect()
        }
      }
    } catch (error) {
      console.error(`An error occurred in `)
    }
  }

  /**
   * @description method to reload chats
   * @param clientId clientId to validate if we need to do reload
   */
  const handleReloadChats = async (clientId) => {
    try {
      const localClientId = JSON.parse(localStorage.getItem('user')).userMetaData.userA3Cloud.clientId
      if (localClientId === clientId) {
        const response = await usageService.getConversationsByMonth('', '', token, 'today', botConfig?.id)
        setChats(response)
      }
    } catch (error) {
      console.error(`An error occurred in handleReloadChats: ${error}`)
    }
  }

  /**
   * @description event to detect if conversation mode changed
   * @param conversationId | string
   */
  const handleCheckConversationModeChanged = async ({conversationId}) => {
    try {
      if (chatsRef.current && chatsRef.current.length > 0 && chatsRef.current.some(c => c.conversationId === conversationId)) {
        const localClientId = JSON.parse(localStorage.getItem('user')).userMetaData.userA3Cloud.clientId
        handleReloadChats(localClientId)
      }
    } catch (error) {
      console.error(`An error occurred in handleReloadChats: ${error}`)
    }
  }

  /**
   * @author Antonio Vazquez
   * @description method to update seen support messages
   * @date 06-11-2025
   * @param {string} conversationId | conversation id
   * @return void
   */
  const handleUpdateSeenSupportMessages = async (conversationId) => {
    try {
      await usageService.messagesSeen(conversationId, 'user')
      socketRef.current.emit('messagesUserSeen', { conversationId })
    } catch (e) {
      console.error(`An error occurred in handleUpdateSeenSupportMessages: ${e}`)
    }
  }
  // #endregion methods

  return (
    <ChatsView
      chatbotUrl={chatbotUrl}
      conversations={chats}
      isLoading={loading}
      token={token}
      handleOnClickConversation={handleUpdateSeenSupportMessages}
      botId={botConfig?.id}
    />
  )
}

export {ChatsAction as default}
